import { InfoCircle } from '@untitledui/icons';
import { toast } from 'sonner';

import { CloseButton } from '@/lib/base/buttons/close-button';

import { PROPOSAL_TOAST_POSITION } from './toastPosition';

const STALE_ACTIONS_TOAST_OPTIONS = {
  duration: 6000,
  position: PROPOSAL_TOAST_POSITION,
  style: {
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
    padding: 0,
  },
};

/**
 * Informational (non-error) notice shown when an approve request is rejected
 * with STALE_ACTIONS — the draft changed server-side while the user was
 * reviewing, so the send was skipped and the latest content has been loaded.
 * Auto-dismisses after 6 seconds.
 */
export function showStaleActionsNotice(): void {
  toast.custom(
    t => (
      <div className='flex items-start gap-3 p-4 bg-bg-primary border border-border-secondary rounded-xl shadow-lg min-w-[320px] max-w-[420px]'>
        <div className='flex items-center justify-center size-9 rounded-full bg-secondary shrink-0 mt-0.5'>
          <InfoCircle
            className='size-5 text-fg-quaternary'
            aria-hidden='true'
          />
        </div>

        <div className='flex-1 min-w-0'>
          <p className='text-sm font-semibold text-fg-primary'>
            Updated – wasn&apos;t submitted
          </p>
          <p className='text-xs text-secondary mt-0.5'>
            This was updated while you were reviewing, so it wasn&apos;t
            submitted. The latest version is now shown – review and approve
            again.
          </p>
        </div>

        <CloseButton
          size='xs'
          label='Dismiss'
          onPress={() => toast.dismiss(t)}
          className='shrink-0'
        />
      </div>
    ),
    STALE_ACTIONS_TOAST_OPTIONS
  );
}
